import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad,
  Route,
  UrlSegment
} from '@angular/router';
import { AuthService } from 'app/shared/auth.service';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    console.log('canActivate: canActivateChild was called');
    return this.isAuthenticated();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    console.log('canActivateChild: canActivateChild was called');
    return this.isAuthenticated();
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    console.log('canLoad: canLoad was called');
    return this.isAuthenticated();
  }

  async isAuthenticated() {
    try {
      const isAuthenticated: boolean = await this.authService.isAuthenticated();
      if (isAuthenticated) {
        return true;
      }
      this.toastr.error('Unauthenticated');
    } catch (e) {
      console.log('isAuthenticated - Error: ', e);
    }
    await this.router.navigate(['/login']);
    return Promise.reject(false);
}
}
